export default __webpack_public_path__ + "static/media/FinishOak.a9c25ba7.png";